import { useMemo } from "react";

const MOBILE_USER_AGENT_REGEX =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i;

const useMobileDropdownInputProps = () => {
    const isMobileDevice = useMemo(() => {
        if (typeof navigator === "undefined") return false;
        return (
            MOBILE_USER_AGENT_REGEX.test(navigator.userAgent) ||
            navigator.maxTouchPoints > 0
        );
    }, []);

    const mobileDropdownInputProps = useMemo(
        () =>
            isMobileDevice
                ? {
                      inputMode: "none" as const,
                      readOnly: true,
                  }
                : {},
        [isMobileDevice]
    );

    return { isMobileDevice, mobileDropdownInputProps };
};

export default useMobileDropdownInputProps;
